import { createRequest } from "helpers/tools";

export const createTrackerConsents = async (consent) => {
    return await createRequest({
        suffix: `trackers/consents`,
        method: "post",
        payload: consent,
        handleError: false,
    });
};

export const getTrackerConsentsAsync = async (id) => {
    return await createRequest({
        suffix: `trackers/${id}/consents`,
        method: "get",
        handleError: false,
    });
};

export const updateConsentsAsync = async (id, data) => {
    return await createRequest({
        suffix: `trackers/consents/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};
